import { MechanicValidator } from './MechanicValidator.ts';
import { TileEdgeType } from '@colonist/game-states';
import { MechanicValidatorShip } from './MechanicValidatorShip.ts';
import { ArrayUtils } from '@colonist/utils';
import { MechanicValidatorPirate } from './MechanicValidatorPirate.ts';
export class MechanicValidatorShipMove extends MechanicValidator {
    canPlayerMoveShip(player) {
        const playerController = this.playerValidators.get(player);
        if (playerController == undefined) return {
            canTakeAction: false,
            errorMessageIfCantTakeAction: {
                key: 'strings:game.errors.noPlayer'
            },
            validHoverLocations: []
        };
        const movableShips = this.getMovableShipsForPlayer(player);
        const shipPlayerState = this.validatorShip.getShipPlayerState(player);
        if (shipPlayerState.hasMovedShipThisTurn) return {
            canTakeAction: false,
            errorMessageIfCantTakeAction: {
                key: 'strings:game.errors.canOnlyMoveOneShipPerTurn'
            },
            validHoverLocations: movableShips
        };
        if (movableShips.length <= 0) return {
            canTakeAction: false,
            errorMessageIfCantTakeAction: {
                key: 'strings:game.errors.noOpenShips'
            },
            validHoverLocations: movableShips
        };
        return {
            canTakeAction: true,
            validHoverLocations: movableShips
        };
    }
    getMovableShipsForPlayer(player) {
        const shipsThatCanBeMoved = [];
        for (const tileEdge of this.mapValidator.tileState.tileEdges){
            var _this_validatorPirate;
            if (tileEdge.owner != player) continue;
            if (tileEdge.type != TileEdgeType.Ship) continue;
            if ((_this_validatorPirate = this.validatorPirate) === null || _this_validatorPirate === void 0 ? void 0 : _this_validatorPirate.isEdgeTouchingTileWithPirate(tileEdge)) continue;
            const edgeIndex = this.mapValidator.tileState.getTileEdgeIndex(tileEdge.hexEdge);
            if (edgeIndex == undefined) continue;
            const whereCouldShipBeMoved = this.validatorShip.whereCanPlayerPlaceShips(player, edgeIndex);
            if (whereCouldShipBeMoved.length == 0) continue;
            if (this.mapValidator.willMovingEdgeTypeBreakClosedRoute(player, tileEdge, TileEdgeType.Ship)) continue;
            if (shipsThatCanBeMoved.includes(edgeIndex)) continue;
            shipsThatCanBeMoved.push(edgeIndex);
        }
        const playerController = this.playerValidators.get(player);
        if (playerController == undefined) return shipsThatCanBeMoved;
        const shipPlayerState = this.validatorShip.getShipPlayerState(player);
        var _shipPlayerState_restrictedShipMovesFrom;
        for (const shipPlacedThisTurn of (_shipPlayerState_restrictedShipMovesFrom = shipPlayerState.restrictedShipMovesFrom) !== null && _shipPlayerState_restrictedShipMovesFrom !== void 0 ? _shipPlayerState_restrictedShipMovesFrom : []){
            ArrayUtils.removeElementFromArray(shipsThatCanBeMoved, shipPlacedThisTurn);
        }
        return shipsThatCanBeMoved;
    }
    constructor(playerValidators, mapValidator, shipState, pirateState){
        super(playerValidators, mapValidator);
        this.validatorShip = new MechanicValidatorShip(playerValidators, mapValidator, shipState, pirateState);
        if (pirateState != undefined) this.validatorPirate = new MechanicValidatorPirate(mapValidator, pirateState);
    }
}
